/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { CompleteTransition } from "./CompleteTransition";
import type { Question } from "./Question";
import type { ScoreThresholdTransition } from "./ScoreThresholdTransition";

export interface Stage {
  id: string;
  questions: Question[];
  transition: CompleteTransition | ScoreThresholdTransition;
}
